<template>
  <div>
    <div class="discipline-evaluated">
      <pcg-checkbox
          class="my-checkbox"
          variant="normal"
          :disabled="!(hasRight('edit_discipline') || hasRight('edit_own_discipline'))"
          v-model="discipline.evaluated"
          @input="changeEvaluated(discipline)"
      >{{ $t('components.dn_main_field.evaluated') }}</pcg-checkbox>
    </div>
    <div class="discipline-evaluated">
      <spinner v-if="recalcSpinner" class="my-spinner-slots"></spinner>
    </div>
  </div>
</template>

<script>
import Spinner from './Spinner.vue'
import hasRight from '../mixins/has_right'
import waitForJobs from '../mixins/wait_for_jobs'
import ApiDiscipline from '../api/disciplins'

export default {
  name: 'DnDisciplineEvaluation',
  mixins: [hasRight, waitForJobs],
  components: { Spinner },
  props: {
    discipline: Object
  },
  data: function () {
    return {
      recalcSpinner: false
    }
  },
  mounted () {
  },
  methods: {
    changeEvaluated (discipline) {
      ApiDiscipline.changeEvaluated(discipline)
          .then(result => {
            const jobId = result.data.jobId
            if (jobId !== undefined) {
              this.recalcSpinner = true
              this.waitForJob(jobId, this.disciplineEvaluated, this.disciplineError)
            }
          })
          .catch(error => {
            console.log(error.response.data)
          })
    },
    disciplineEvaluated () {
      this.recalcSpinner = false
    },
    disciplineError () {
      this.recalcSpinner = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/stylesheets/vars';

.discipline-evaluated {
  display: inline;
  float: right;
}

.my-checkbox {
  margin-left: 1rem;
  position: relative;
  top: .4rem;
  float: left;
  display: inline;
  font-size: $font-size-m;
  /deep/ .pcg-checkbox-container {
    margin-right: 0 !important;
  }
}

.my-spinner-slots {
  color: $main-active-color;
  margin-right: .2rem;
  margin-left: .2rem;
  position: relative;
  top: .45rem
}
</style>

<style lang="scss" scoped>
@import "../assets/stylesheets/vars-contrast";
.contrast {
  .my-spinner-slots {
    color: $main-active-color;
  }
}
</style>
